<template>
  <div>
    <div
      class="flex flex-direction justify-center align-center"
      style="background-color: #003366;"
      :style="UI.isMobile ? 'width: 100vw' : 'width: calc(100vw - 8px)'"
    >
      <div class="full-width" v-if="UI.isMobile">
        <div
          class="flex align-center justify-between full-width mobile-header-container"
        >
          <i
            @click="pMenu = !pMenu"
            class="el-icon-menu font-18 margin-left-sm text-white"
          ></i>
          <div
            class="flex align-center justify-end margin-right-sm"
            style="max-width: 50%;"
          >
            <el-dropdown trigger="hover" @command="handleCommand">
              <span class="el-dropdown-link " v-if="User.user.username">
                {{ User.user.username }} [{{ roleLabel }}]
                <el-tag
                  v-if="approveValue !== null"
                  size="mini"
                  :type="approveBtn[approveValue]"
                  style="margin: 0 4px;"
                >
                  {{ $getApproveLabel(approveValue) }}
                </el-tag>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>

              <span class="el-dropdown-link " @click="login" v-else>
                登录/注册
              </span>

              <el-dropdown-menu slot="dropdown" v-if="User.user.username">
                <el-dropdown-item command="info">用户信息</el-dropdown-item>
                <el-dropdown-item command="role">
                  注册其他角色
                </el-dropdown-item>
                <el-dropdown-item command="organizationApprove">
                  {{
                    User.organization_info.organization
                      ? '修改单位认证'
                      : '单位认证'
                  }}
                </el-dropdown-item>
                <el-dropdown-item
                  command="userInfoApprove"
                  v-if="User.user.role != $roleConsts.ORG.value"
                >
                  {{ User.user_info.name ? '修改注册信息' : '信息注册' }}
                </el-dropdown-item>
                <el-dropdown-item
                  command="joinGameInfo"
                  v-if="
                    User.user.role == $roleConsts.PLAYER.value ||
                      User.user.role == $roleConsts.ORG_PLAYER.value
                  "
                >
                  参赛信息
                </el-dropdown-item>
                <el-dropdown-item
                  command="joinOrgGameInfo"
                  v-if="User.user.role == $roleConsts.ORG.value"
                >
                  参赛信息
                </el-dropdown-item>
                <el-dropdown-item command="changePwd">
                  修改密码
                </el-dropdown-item>
                <el-dropdown-item command="login">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <el-collapse-transition v-if="!pMenu">
          <slot></slot>
        </el-collapse-transition>
      </div>

      <div class="header-container" v-else>
        <el-row>
          <el-col :span="24">
            <div class="full-item flex justify-between align-center">
              <div
                class="flex align-center cursor-pointer"
                @click="toIndex"
                style="width: 350px;"
              >
                <img style="height: 50px;" src="/static/img/logo.png" />
                <div class="text-white margin-left-xs font-weight-500">
                  中 国 滑 雪 登 山
                </div>
              </div>
              <div class="full-item flex align-center">
                <div class="font-20">{{ title }}</div>
                <slot></slot>
              </div>
              <div class="flex align-center justify-end" style="width: 350px;">
                <img
                  class="margin-right-xs"
                  style="height: 40px;"
                  fit="contain"
                  :src="
                    User.user_info.avatar
                      ? User.user_info.avatar
                      : '/static/img/avatar.png'
                  "
                  :preview-src-list="
                    User.user_info.avatar ? [User.user_info.avatar] : []
                  "
                />
                <span
                  class="el-dropdown-link"
                  @click="login"
                  v-if="!User.user.username"
                >
                  登录/注册
                </span>
                <el-dropdown trigger="hover" @command="handleCommand" v-else>
                  <span class="el-dropdown-link text-center">
                    {{ User.user.username }} [{{ roleLabel }}]
                    <el-tag
                      v-if="approveValue !== null"
                      size="mini"
                      :type="approveBtn[approveValue]"
                      style="margin: 0 4px;"
                    >
                      {{ $getApproveLabel(approveValue) }}
                    </el-tag>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>

                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="info">用户信息</el-dropdown-item>
                    <el-dropdown-item command="role">
                      注册其他角色
                    </el-dropdown-item>

                    <el-dropdown-item command="organizationApprove">
                      {{
                        User.organization_info.organization
                          ? '修改单位认证'
                          : '单位认证'
                      }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      command="userInfoApprove"
                      v-if="User.user.role != $roleConsts.ORG.value"
                    >
                      {{ User.user_info.name ? '修改注册信息' : '信息注册' }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      command="joinGameInfo"
                      v-if="
                        User.user.role == $roleConsts.PLAYER.value ||
                          User.user.role == $roleConsts.ORG_PLAYER.value
                      "
                    >
                      参赛信息
                    </el-dropdown-item>
                    <el-dropdown-item
                      command="joinOrgGameInfo"
                      v-if="User.user.role == $roleConsts.ORG.value"
                    >
                      参赛信息
                    </el-dropdown-item>
                    <el-dropdown-item command="changePwd">
                      修改密码
                    </el-dropdown-item>
                    <el-dropdown-item command="login">
                      退出登录
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { showErrorMsg } from '@/utils/uiUtils.js';

export default {
  name: 'Header',

  computed: {
    ...mapState(['UI', 'User']),

    approveValue: function() {
      const target =
        this.User.user.role == this.$roleConsts.ORG.value
          ? this.User.organization_info
          : this.User.user_info;
      if (
        !target ||
        target.is_approved === undefined ||
        target.is_approved === null
      ) {
        return null;
      }
      return target.is_approved;
    },

    isTechOfficer: function() {
      return this.User.user.role == this.$roleConsts.TECH_OFFICER.value;
    },

    roleLabel: function() {
      const role = this.getRole();
      if (!this.isTechOfficer) {
        return role;
      }
      const level = (this.User.user_info.referee_level || '').trim();
      return `${role}-${level || '无'}`;
    },
  },

  data() {
    return {
      pMenu: true,
      approveBtn: ['warning', 'success', 'danger', 'info'],
    };
  },

  props: {
    title: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleCommand: function(command) {
      if (
        command == 'organizationApprove' &&
        this.User.organization_info.is_approved ==
          this.$approveConsts.APPROVED.value
      ) {
        showErrorMsg('信息已审核，请先联系管理员驳回');
      } else if (
        command == 'userInfoApprove' &&
        this.User.user_info.is_approved == this.$approveConsts.APPROVED.value
      ) {
        showErrorMsg('信息已审核，请先联系管理员驳回');
      } else if (command == 'joinGameInfo') {
        this.$router.replace({
          name: 'playerInfo',
          query: { id: this.User.user.id },
        });
      } else if (command == 'joinOrgGameInfo') {
        this.$router.replace({
          name: 'orgPlayerInfo',
        });
      } else {
        if (command == 'login') {
          this.User.hasLogin = false;
          this.User.user = {};
          this.User.organization_info = {};
          this.User.user_info = {};
        }

        this.$router.replace({
          name: command,
        });
      }
    },

    login: function() {
      this.$router.push({
        name: 'login',
      });
    },

    toIndex: function() {
      this.$router.push({
        path: '/',
      });
    },

    getRole: function() {
      for (let key in this.$roleConsts) {
        if (this.$roleConsts[key].value == this.User.user.role) {
          return this.$roleConsts[key].label;
        }
      }
      return '其他';
    },
  },
};
</script>

<style lang="scss">
.body-height {
  height: calc(100vh - 180px);
  overflow-y: auto;
}

.mobile-header-container {
  height: 50px;

  .el-dropdown-link {
    color: #ffffff;
  }

  .el-icon-arrow-down {
    font-size: 18px;
  }

  .el-submenu {
    width: 100%;
  }

  .demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
  }
}

.header-container {
  height: 70px;

  .el-dropdown-link {
    cursor: pointer;
    color: #ffffff;
  }

  .el-icon-arrow-down {
    font-size: 18px;
  }

  .demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue